import { Alert, Box, Link, Stack, Typography } from '@mui/material'
import { useContext, useMemo, useState } from 'react'
import { Link as RouterLink } from 'react-router-dom'

import { AppRoutes } from '../../../models'
import { FeatureFlags } from '../../../models/FeatureFlags'
import { AppContext } from '../../../providers/AppProvider/AppProvider'
import { RepairOrderContext } from '../../../providers/RepairOrderProvider/RepairOrderProvider'
import { CarfaxButton } from '../../Settings/CarfaxButton'
import { MilesInText } from '../../Vehicles/MilesInText'
import { AiHighlights } from './AiHighlights'

export const AiHighlightsContainer = () => {
  const { vehicle, repairOrder } = useContext(RepairOrderContext)
  const { shopProfile, featureFlags } = useContext(AppContext)
  const isCarfaxDemoAccount =
    featureFlags && featureFlags[FeatureFlags.CarfaxDemo]
  const vinError = !vehicle?.info?.vin
  const shopProfileError = isCarfaxDemoAccount
    ? false
    : !shopProfile?.info!.enableCarfax || !shopProfile?.info!.carfaxAuthorized
  const milesError = repairOrder?.entry!.info!.mileageIn === undefined

  const helperText = useMemo(() => {
    if (!vinError && !shopProfileError && !milesError) {
      return ''
    }
    const text: string[] = []
    if (vinError) {
      text.push("provide vehicle's VIN")
    }
    if (shopProfileError) {
      text.push('enable CarFax in your shop settings')
    }
    if (milesError) {
      text.push('update the current mileage')
    }
    text[0] = 'Please ' + text[0]
    if (text.length > 1) {
      text.push('and ' + text.pop())
    }
    return text.join(', ') + ' to use AI recommendations'
  }, [vinError, shopProfileError, milesError])

  const [show, setShow] = useState(true)

  const [milesIn, setMilesIn] = useState<number | undefined>(
    repairOrder?.entry!.info!.mileageIn
  )

  return (
    <Box mb={1}>
      {helperText ? (
        show && (
          <Alert
            severity="info"
            onClose={() => {
              setShow(false)
            }}>
            <Typography>{helperText}</Typography>
            <Stack direction="row" spacing={2} alignItems={'center'}>
              {vinError && (
                <Link
                  component={RouterLink}
                  to={AppRoutes.VEHICLES + '/' + vehicle?.id!}>
                  <Typography>Go to vehicle page to add VIN</Typography>
                </Link>
              )}
              {shopProfileError && <CarfaxButton shopEntry={shopProfile} />}
              {milesError && repairOrder && vehicle && (
                <MilesInText
                  repairOrder={repairOrder}
                  vehicle={vehicle}
                  milesIn={milesIn}
                  setMilesIn={setMilesIn}
                  size={'small'}
                  sx={{
                    width: '15ch'
                  }}
                />
              )}
            </Stack>
          </Alert>
        )
      ) : (
        <AiHighlights />
      )}
    </Box>
  )
}
